<template>
  <div class="index">
    <div v-if="baseData.type==2&&meeting_data.back_menu_type==2" style="height:44px"></div>
    <!-- <expertsList></expertsList> -->
    <component class="" v-for="(item, index) in listData" :is="item.type" :index='index' :meeting_data='meeting_data'
      :key="index">
    </component>
    <div v-if="meeting_data.background_img_path" class="bgc_img">
      <img :src="meeting_data.background_img_path" alt="">
    </div>
    <div v-if="meeting_data.tail_img_path" class="bottom_img">
      <img :src="meeting_data.tail_img_path" alt="">
    </div>

    <backhome :baseData="baseData" :meeting_data='meeting_data' v-if="baseData.id!=baseData.home_page_id"></backhome>
  </div>
</template>

<script> 
import $ from 'jquery';
import { getWXConfig } from "@/api/login.js";
import backhome from '@/components/backHome.vue';
import { getPageData } from "@/api/meetApi";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
export default {
  props: ["sharePower"],
  components: { backhome },
  name: "index",
  data() {
    return {
      listData: [],
      meeting_data: {},
      baseData: {},
    };
  },

  watch: {
    // 监视搜索词变化1
    "$route.query.view_id": {
      immediate: true,
      deep: true,
      handler() {
        $('html,body').animate({
          scrollTop: 0
        }, 0);
        this.getData();
      },
    },
  },
  async created() {
    $("html,body").animate({
      scrollTop: 0
    }, 500);
    const requireComponents = require.context(
      "@/components/workPlace",
      true,
      /\.vue/
    );
    requireComponents.keys().forEach((fileName) => {
      const reqCom = requireComponents(fileName);
      const reqComName = reqCom.name || fileName.replace(/\.\/(.*)\.vue/, "$1");
      Vue.component(reqComName, reqCom.default || reqCom);
    });

    let bgc = JSON.parse(localStorage.getItem('meeting_data'))
    if (bgc.id == this.$route.query.meeting_id) {
      this.meeting_data = bgc
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    ...mapGetters(["workPlace"]),
    ...mapGetters(["okForm"]),
  },
  methods: {
    moment,
    ...mapActions("workPlace", ["set_workPlace"]),
    async getData() {
      if (!this.$route.query.view_id) {
        return
      }
      let data = await getPageData({ view_id: this.$route.query.view_id });
      if (data.payload && data.payload.msg) {
        return this.$message.error(data.payload.msg)
      }
      this.meeting_data = data.payload.meeting_data
      this.listData = data.payload.component_arr;
      this.baseData = data.payload.view_data;
      document.title = this.baseData.title
      this.share()
      if (this.meeting_data.background_color) {
        document.querySelectorAll('body')[0].style.backgroundColor = this.meeting_data.background_color
        localStorage.setItem('meeting_data', JSON.stringify(this.meeting_data))
      }

      this.workPlace.okForm = JSON.parse(JSON.stringify(this.listData));

    },

    async share() {
      // 判断是否有meeting_id，用于记录访问次数
      let data = null
      if (this.meeting_data && this.meeting_data.id) {
        data = await getWXConfig({ url: window.location.href, meeting_id: this.meeting_data.id })
      } else {
        data = await getWXConfig({ url: window.location.href })
      }

      let reg = /\\r\\n/ig
      // 优先使用自定义的分享配置，如果没有则使用大会得默认配置
      // 当所有参数都没有时，会在wxConfig.js中生成默认配置
      // 七个参数分别为（分享配置，聊天标题，聊天图片，聊天介绍，朋友圈标题，朋友圈图片，朋友圈介绍）
      // 分享链接在wxConfig.js中生成，为当前页面链接
      this.WXConfig.wxShowMenu(
        data.payload,
        this.baseData.wechat_share_title ? this.baseData.wechat_share_title.replace(reg, "\r\n") : this.baseData.title.replace(reg, "\r\n"),
        this.baseData.wechat_share_img_path ? this.baseData.wechat_share_img_path : this.meeting_data.wechat_share_img_path,
        this.baseData.wechat_share_content ? this.baseData.wechat_share_content.replace(reg, "\r\n") : this.meeting_data.wechat_share_content.replace(reg, "\r\n"),
        this.baseData.moments_share_title ? this.baseData.moments_share_title.replace(reg, "\r\n") : this.baseData.title.replace(reg, "\r\n"),
        this.baseData.moments_share_img_path ? this.baseData.moments_share_img_path : this.meeting_data.moments_share_img_path,
        this.baseData.moments_share_content ? this.baseData.moments_share_content.replace(reg, "\r\n") : this.meeting_data.moments_share_content.replace(reg, "\r\n"),
      );
    }
  },
};
</script>

<style>
html,
body {
  /* background-color: #c0dded; */
  z-index: -2;
  position: relative;
}
.index {
  min-height: 100vh;
  position: relative;
  padding-bottom: 0.1px;
}
.bottom_img {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: -1;
}
.bottom_img img {
  width: 100%;
}
.bgc_img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100%;
  width: 100%;
  min-height: 100vh;
}
.bgc_img img {
  width: 100%;
  height: 100%;
}

.back {
  position: fixed;
  bottom: 10px;
  width: 40px;
  height: 120px;
  background-color: red;
  right: 10px;
}
::-webkit-scrollbar {
  width: 0px;
}
::scrollbar {
  width: 0px;
}
</style> 